import React from 'react';
import { FaLinkedin, FaGithub, FaTwitter, FaInstagram, FaFacebook, FaDiscord, FaWhatsapp, FaTelegram, FaResearchgate } from 'react-icons/fa';
import { SiHuggingface } from 'react-icons/si';

const volunteering = [
  {
    title: "Volunteering",
    organization: "Urban Life Church",
    role: "Online Producer and Tech Volunteer",
    duration: "August 2022 · Present",
    category: "Faith & Community",
  }
];

const About = () => {

  const socialLinks = [
    { name: 'LinkedIn', icon: FaLinkedin, url: 'https://www.linkedin.com/feed/', color: 'hover:text-blue-400' },
    { name: 'GitHub', icon: FaGithub, url: 'https://github.com/reaganscofield', color: 'hover:text-gray-300' },
    { name: 'Twitter', icon: FaTwitter, url: 'https://x.com/ReaganScofield', color: 'hover:text-blue-400' },
    { name: 'Instagram', icon: FaInstagram, url: 'https://www.instagram.com/reagan_scofield/', color: 'hover:text-pink-400' },
    { name: 'Facebook', icon: FaFacebook, url: 'https://www.facebook.com/reaganscofield23', color: 'hover:text-blue-600' },
    { name: 'WhatsApp', icon: FaWhatsapp, url: 'https://wa.me/+27719886641', color: 'hover:text-green-400' },
    { name: 'Telegram', icon: FaTelegram, url: 'https://t.me/reaganscofield', color: 'hover:text-blue-500' },
    { name: 'ResearchGate', icon: FaResearchgate, url: 'https://www.researchgate.net/profile/Reagan-Mukandila?ev=hdr_xprf', color: 'hover:text-teal-400' },
    { name: 'Hugging Face', icon: SiHuggingface, url: 'https://huggingface.co/reaganscofield', color: 'hover:text-yellow-600' },
  ];

  return (
      <div className="min-h-screen p-8 pt-24 bg-gradient-to-br from-slate-900 to-slate-900">
        <div className="container mx-auto space-y-16">
          {/* Introduction Section */}
          <section className="text-center">
            <div className="bg-gradient-to-br from-gray-800/90 to-gray-900/90 backdrop-blur-sm border border-gray-700/50 rounded-xl shadow-2xl p-8  mx-auto">
              
              {/* Header with Image and Name */}
              <div className="flex flex-col lg:flex-row items-center justify-center gap-8 mb-8">
                {/* Profile Image */}
                <div className="relative flex-shrink-0">
                  <div className="w-40 h-40 lg:w-48 lg:h-48 mx-auto rounded-full overflow-hidden border-4 border-gradient-to-r from-cyan-400 to-purple-400 shadow-2xl shadow-cyan-500/20 relative">
                    <img 
                      src="images/reagan.png"
                      // src="https://media.licdn.com/dms/image/v2/D4D35AQEUv9FG-864tQ/profile-framedphoto-shrink_200_200/profile-framedphoto-shrink_200_200/0/1736244636675?e=1749502800&v=beta&t=kumK-AXqzTK0RBF8vFYM1RbBoFC3Dl73PPZ5-foH4aQ"
                      alt="Reagan Scofield"
                      className="w-full h-full object-cover"
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.nextElementSibling.classList.remove('hidden');
                      }}
                    />
                    <div 
                      className="w-full h-full bg-gradient-to-br from-cyan-500 to-purple-500 flex items-center justify-center text-4xl font-bold text-white hidden absolute top-0 left-0"
                    >
                      RS
                    </div>
                  </div>
                  {/* Animated ring around image */}
                  <div className="absolute inset-0 w-40 h-40 lg:w-48 lg:h-48 mx-auto rounded-full border-2 border-cyan-400/30 animate-ping"></div>
                  {/* Status indicator */}
                  <div className="absolute bottom-2 right-2 lg:bottom-4 lg:right-4 w-6 h-6 bg-green-400 rounded-full border-2 border-gray-800 shadow-lg">
                    <div className="w-full h-full bg-green-400 rounded-full animate-pulse"></div>
                  </div>
                </div>

                {/* Name and Title */}
                <div className="flex-1 text-center lg:text-left">
                  <h1 className="text-4xl lg:text-6xl font-bold bg-gradient-to-r from-cyan-400 to-purple-400 bg-clip-text text-transparent mb-4">
                    Reagan Scofield
                  </h1>
                  <h2 className="text-xl lg:text-2xl text-emerald-400 font-semibold mb-4">
                    Software | AI/ML Engineer
                  </h2>
                  
                  {/* Location and University */}
                  <div className="flex flex-col lg:flex-row items-center justify-center lg:justify-start gap-2 lg:gap-4 text-gray-400 mb-4">
                    <div className="flex items-center gap-2">
                      <div className="w-2 h-2 bg-cyan-400 rounded-full"></div>
                      <span className="text-sm">Johannesburg, South Africa</span>
                    </div>
                    <div className="hidden lg:block w-1 h-1 bg-gray-600 rounded-full"></div>
                    <div className="flex items-center gap-2">
                      <div className="w-2 h-2 bg-purple-400 rounded-full"></div>
                      <span className="text-sm">Open to Work</span>
                    </div>
                  </div>

                  {/* Quick Action Buttons */}
                  <div className="flex flex-col sm:flex-row gap-3 justify-center lg:justify-start">
                    <a
                      href="/contact"
                      className="px-6 py-2.5 bg-gradient-to-r from-cyan-500 to-purple-500 text-white font-semibold rounded-full shadow-lg hover:from-cyan-400 hover:to-purple-400 hover:shadow-cyan-500/20 transition-all duration-300 transform hover:scale-105"
                    >
                      Get In Touch
                    </a>
                    <a
                      href="/projects"
                      className="px-6 py-2.5 border-2 border-cyan-400 text-cyan-400 font-semibold rounded-full hover:bg-cyan-400 hover:text-slate-900 hover:shadow-lg hover:shadow-cyan-400/20 transition-all duration-300"
                    >
                      View Projects
                    </a>
                  </div>
                </div>
              </div>
              
              {/* Description */}
              <h2 className="text-xl font-semibold text-white mb-4">Welcome to my portfolio.</h2>
              <div className="text-gray-300 text-lg leading-relaxed mb-8 space-y-4 max-w-4xl mx-auto">
                <p>
                 I am an innovative and results-driven Software Engineer and Machine Learning Engineer with over 7+ 
                 years of experience building and scaling high-performance, real-time systems in production 
                 environments. My expertise spans full-stack development, distributed systems, DevOps, and cloud 
                 infrastructure, with a strong focus on reliability, scalability, and performance.
                </p>
                <p>
                 I currently design and maintain mission-critical backend systems powering emergency response 
                 operations across South Africa, Kenya, the United Kingdom, and the United States, where system 
                 reliability directly impacts real-world outcomes. My work involves architecting event-driven and 
                 microservices-based systems, optimising PostgreSQL queries at scale, and implementing high-throughput 
                 APIs that support large, distributed user bases.
                </p>
                {/* <p>I have led and contributed to:</p>
                <ul className="list-disc list-inside text-gray-400 space-y-2">
                  <li>Designing scalable, high-availability backend architectures for real-time dispatch and responder coordination systems.</li>
                  <li>Building and optimising CI/CD pipelines, improving deployment speed, safety, and cross-region stability.</li>
                  <li>Migrating legacy systems into modular microservices, improving maintainability and system resilience.</li>
                  <li>Implementing advanced database optimisations and indexing strategies to significantly reduce latency.</li>
                  <li>Leading end-to-end system testing and production deployments, ensuring operational continuity across multiple regions.</li>
                  <li>Mentoring engineers and driving engineering best practices within teams</li>
                </ul> */}
                <p>
                  Beyond traditional software engineering, I actively integrate Machine Learning into production systems, 
                  designing models to predict responder behaviour (acceptance, decline, stand-down) using real-world 
                  operational data. I am deeply interested in building intelligent systems that move beyond static logic 
                  into decision-support and predictive capabilities, bridging the gap between backend engineering 
                  and applied AI.
                </p>
                <p>
                  My technical stack includes Python, Node.js, TypeScript, PostgreSQL, Redis, AWS, Docker, and modern 
                  data/ML tooling. I am particularly passionate about system design, performance engineering, and AI-driven 
                  backend systems.
                </p>
                <p>I thrive in environments that demand ownership, impact, and precision, and I am driven by a mission to build software that is not only scalable and efficient, but also meaningful in the real world.</p>
              </div>

              {/* Social Media Links */}
              <div className="mb-6">
                <h3 className="text-xl font-semibold text-white mb-4">
                  Connect with me across platforms
                </h3>
                <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-8 xl:grid-cols-9 gap-3">
                  {socialLinks.map((social, index) => {
                    const IconComponent = social.icon;
                    return (
                      <a
                        key={index}
                        href={social.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`text-gray-400 ${social.color} transition-all duration-300 transform hover:scale-110 p-3 bg-gray-800/50 rounded-lg border border-gray-700/30 hover:border-gray-600/50 group relative`}
                        title={social.name}
                      >
                        <IconComponent className="text-xl" />
                        <span className="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap z-10">
                          {social.name}
                        </span>
                      </a>
                    );
                  })}
                </div>
              </div>
              
              {/* Quick Stats */}
              {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
                <div className="text-center">
                  <div className="text-3xl font-bold text-cyan-400 mb-2">50+</div>
                  <div className="text-gray-300 text-sm">Certifications</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-purple-400 mb-2">20+</div>
                  <div className="text-gray-300 text-sm">Research Ideas</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-emerald-400 mb-2">10+</div>
                  <div className="text-gray-300 text-sm">Projects Completed</div>
                </div>
              </div> */}
            </div>
          </section>

          {/* AI Facts Section */}
          {/* <AiFacts /> */}

          {/* Certificate Badges Section */}
          {/* <section>
            <div className="bg-gradient-to-br from-gray-800/90 to-gray-900/90 backdrop-blur-sm border border-gray-700/50 rounded-xl shadow-2xl p-8 max-w-7xl mx-auto">
              <div className="text-center mb-6">
                <h2 className="text-4xl font-bold bg-gradient-to-r from-cyan-400 to-purple-400 bg-clip-text text-transparent mb-3">
                  Certificate Badges
                </h2>
                <p className="text-gray-400 text-sm mb-4">
                  Featured certification badges - Click on any badge to view details
                </p>
                <a
                  href="/gallery"
                  className="inline-flex items-center gap-2 px-6 py-2.5 bg-gradient-to-r from-cyan-500/20 to-purple-500/20 border border-cyan-500/30 rounded-full text-cyan-400 text-sm font-medium hover:from-cyan-500/30 hover:to-purple-500/30 transition-all duration-300"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                  View Full Gallery ({certifications.filter(cert => cert.badge).length} Certificates)
                </a>
              </div>
              <CertificationBadges 
                certifications={certifications}
                maxItems={6}
                showCategory={true}
              />
            </div>
          </section> */}

          {/* Certifications Section */}
          <section>
            {/* <h2 className="text-5xl font-bold text-center bg-gradient-to-r from-cyan-400 to-purple-400 bg-clip-text text-transparent mb-12">
              Certifications
            </h2>
            <div className="columns-1 sm:columns-2 md:columns-3 lg:columns-4 gap-6">
              {certificationsToShow.map((cert, index) => (
                <div
                  key={index}
                  className="break-inside-avoid mb-6 bg-gradient-to-br from-gray-800/90 to-gray-900/90 backdrop-blur-sm border border-gray-700/50 rounded-xl shadow-2xl p-6 transition-all duration-300 hover:-translate-y-2 hover:shadow-cyan-500/20 hover:border-cyan-500/50"
                >
                  <h3 className="text-xl font-semibold text-white border-b border-gray-600 pb-2 mb-4">
                    {cert.title}
                  </h3>
                  <div className="text-gray-300 text-sm space-y-2">
                    <p><span className="text-cyan-400 font-medium">Issuer:</span> {cert.issuer}</p>
                    <p><span className="text-cyan-400 font-medium">Issued:</span> {cert.issuedDate}</p>
                    {cert.credentialId && (
                      <p><span className="text-cyan-400 font-medium">Credential ID:</span> {cert.credentialId}</p>
                    )}
                    {cert.skills && (
                      <p><span className="text-cyan-400 font-medium">Skills:</span> {cert.skills}</p>
                    )}
                  </div>
                  {cert.credentialUrl && (
                    <a
                      href={cert.credentialUrl}
                      className="inline-block mt-4 px-4 py-2 bg-gradient-to-r from-cyan-500 to-purple-500 text-white rounded-lg text-sm font-medium hover:from-cyan-400 hover:to-purple-400 transition-all duration-300"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Show credential
                    </a>
                  )}
                </div>
              ))}
            </div> */}
            
            {/* {certifications.length > 8 && (
              <div className="text-center mt-8">
                <button
                  onClick={() => setShowAllCertifications(!showAllCertifications)}
                  className="flex items-center justify-center mx-auto px-6 py-3 bg-gradient-to-r from-cyan-500 to-purple-500 text-white font-semibold rounded-lg hover:from-cyan-400 hover:to-purple-400 transition-all duration-300 transform hover:scale-105"
                >
                  {showAllCertifications ? (
                    <>
                      <FaChevronUp className="mr-2" />
                      Show Less
                    </>
                  ) : (
                    <>
                      <FaChevronDown className="mr-2" />
                      View All Certifications ({certifications.length - 8} more)
                    </>
                  )}
                </button>
              </div>
            )} */}
          </section>

          {/* Recommendations Section */}
          {/* <section>
            <div className="bg-gradient-to-br from-gray-800/90 to-gray-900/90 backdrop-blur-sm border border-gray-700/50 rounded-xl shadow-2xl p-8 max-w-7xl mx-auto">
              <div className="text-center mb-12">
                <h2 className="text-5xl font-bold bg-gradient-to-r from-emerald-400 to-cyan-400 bg-clip-text text-transparent mb-3">
                  Recommendations
                </h2>
                <p className="text-gray-400 text-sm max-w-2xl mx-auto">
                  What colleagues and mentors say about working with me
                </p>
              </div>
              <Recommendations 
                recommendations={recommendations}
                maxItems={6}
              />
            </div>
          </section> */}

          <section>
            <h2 className="text-5xl font-bold text-center bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent mb-12">
              Volunteering
            </h2>
            <div className="columns-1 sm:columns-2 gap-6">
              {volunteering.map((vol, index) => (
                <div
                  key={index}
                  className="break-inside-avoid mb-6 bg-gradient-to-br from-gray-800/90 to-gray-900/90 backdrop-blur-sm border border-gray-700/50 rounded-xl shadow-2xl p-6 transition-all duration-300 hover:-translate-y-2 hover:shadow-purple-500/20 hover:border-purple-500/50"
                >
                  <h3 className="text-xl font-semibold text-white border-b border-gray-600 pb-2 mb-4">
                    {vol.title}
                  </h3>
                  <div className="text-gray-300 text-sm space-y-2">
                    <p><span className="text-purple-400 font-medium">Organization:</span> {vol.organization}</p>
                    <p><span className="text-purple-400 font-medium">Role:</span> {vol.role}</p>
                    <p><span className="text-purple-400 font-medium">Duration:</span> {vol.duration}</p>
                    {vol.category && (
                      <p><span className="text-purple-400 font-medium">Category:</span> {vol.category}</p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </section>
        </div>
      </div>
  );
};

export default About;
